var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image is-32x32 effect",attrs:{"title":_vm.tooltip}},[_c('img',{attrs:{"src":_vm.getIconPath,"height":"32","width":"32"}}),_c('p',{staticClass:"effect-value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }